export default function Todo(props){
    return (
    <>
        {props.children}   
    </>
    );
}
